export default __webpack_public_path__ + "static/media/file-svgrepo-com.727bbc23.svg";